import { at } from "lodash";
import { useField } from "formik";
import Autocomplete from "@mui/material/Autocomplete";
import TextField from "@mui/material/TextField";

interface AutocompleteFieldProps {
  name: string;
  data: any;
  setFieldValue: (name: string, value: any) => void;
  getOptionLabel?: (value: any) => string;
  disabled?: boolean;
  isOptionEqualToValue?: (option: any, value: any) => boolean;
}

export default function AutocompleteField(props: AutocompleteFieldProps) {
  const {
    name,
    data,
    setFieldValue,
    getOptionLabel,
    disabled,
    isOptionEqualToValue,
  } = props;
  const [field, meta] = useField(props);
  const { value: selectedValue } = field;
  const [error] = at(meta, "error");

  return (
    <>
      <Autocomplete
        options={data ? data : []}
        value={!!selectedValue && selectedValue !== "" ? selectedValue : null}
        clearOnEscape={true}
        clearOnBlur={true}
        onChange={(_, value) => setFieldValue(name, value)}
        renderInput={(params) => (
          <TextField {...params} helperText={error} error={!!error} />
        )}
        getOptionLabel={getOptionLabel}
        isOptionEqualToValue={
          isOptionEqualToValue
            ? isOptionEqualToValue
            : (option, value) => option.id === value.id
        }
        disabled={disabled}
      />
    </>
  );
}
